import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
  },

  actions: {
    // 获取app信息
    async getAppInfoX ({ commit }, params) {
      const response = await axios.get('/wechat/init', { params })
      return response.data
    },
    // 绑定
    async binding ({ commit }, params) {
      const response = await axios.post('/wechat/binding', params)
      return response.data
    },
    // 解绑
    async unbinding ({ commit }, params) {
      const response = await axios.post('/wechat/unbinding', params)
      return response.data
    }
  }
}
